"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleValue = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _core = require("@emotion/core");
var _reactSelect = require("react-select");
var _colors = require("../../../constants/colors");
/** @jsxRuntime classic */
/** @jsx jsx */

const disabledColor = (0, _colors.toRgba)(_colors.neutralDark40, 0.3);
const SingleValue = _ref => {
  let {
    children,
    ...rest
  } = _ref;
  return (0, _core.jsx)(_reactSelect.components.SingleValue, (0, _extends2.default)({}, rest, {
    css: (0, _core.css)`
                color: ${rest.isDisabled ? disabledColor : _colors.neutralDark40};
                font-weight: 600;
                font-size: 13px;
                line-height: 18px;
                margin: 0;
                padding: 0 8px;
            `
  }), children);
};
exports.SingleValue = SingleValue;
//# sourceMappingURL=SingleValue.js.map